module.exports = __webpack_public_path__ + "img/ar_configuration.a0163708.png";